import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';

import TabSingleTextWrapper from '../../../../common/tabSingleTextWrapper';

const Phase3 = forwardRef(({ permissions: { disableEdit }, data }, ref) => {
  const {
    current: { phases, id: drugId, ingestedId },
    original: { phases: originalData },
    ingested: {
      phases: { data: ingestedData, fieldActions: ingestedActions },
    },
  } = useSelector(state => state.drugs, shallowEqual);
  return (
    <TabSingleTextWrapper
      disableEdit={disableEdit}
      footerData={data}
      data={phases}
      parentKey="phases"
      childKey="phaseIII"
      drugId={drugId}
      ingestedId={ingestedId}
      originalData={originalData}
      ingestedData={ingestedData['phaseIII']}
      ingestionAction={ingestedActions['phaseIII']}
      parentIngestionAction={ingestedActions}
      ref={ref}
    />
  );
});

Phase3.propTypes = {
  permissions: PropTypes.object.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    isTab: PropTypes.bool.isRequired,
    tabs: PropTypes.array.isRequired,
  }),
};

Phase3.displayName = 'Phase3';

export default Phase3;
